// extracted by mini-css-extract-plugin
export default {"funnelChartContainer":"FunnelChart_funnelChartContainer__2eCDa","labelText":"FunnelChart_labelText__z1SQA"};